import { useData } from "../providers/ContextProvider";
import { NavLink } from "react-router-dom";
import logo from "../images/owl-white.svg";

function Header() {
  const {
    state: { isLoggedIn },
    dispatch,
  } = useData();

  return (
    <div className="nav-container">
      <div className="nav">
        <NavLink to="/" className="logo-container">
          <img src={logo} className="logo" alt="logo" />
          <span className="logo-text"> ezHabit</span>
        </NavLink>
        <nav className="nav-list">
          <NavLink
            to="/app/home"
            className={({ isActive }) =>
              isActive
                ? "nav-link hover-underline-animation active"
                : "nav-link hover-underline-animation"
            }
          >
            Home
          </NavLink>
          <NavLink
            to="/app/leaderboard"
            className={({ isActive }) =>
              isActive
                ? "nav-link hover-underline-animation active"
                : "nav-link hover-underline-animation"
            }
          >
            Leaderboard
          </NavLink>
          <NavLink
            to="/app/newsfeed"
            className={({ isActive }) =>
              isActive
                ? "nav-link hover-underline-animation active"
                : "nav-link hover-underline-animation"
            }
          >
            Newsfeed
          </NavLink>
          <NavLink
            to="/app/challenges"
            className={({ isActive }) =>
              isActive
                ? "nav-link hover-underline-animation active"
                : "nav-link hover-underline-animation"
            }
          >
            Challenges
          </NavLink>
          <NavLink
            to="/app/add-score"
            className={({ isActive }) => {
              return isActive
                ? "nav-link hover-underline-animation active"
                : "nav-link hover-underline-animation";
            }}
          >
            Add Score
          </NavLink>
          <NavLink
            to="/app/view-goals"
            className={({ isActive }) =>
              isActive
                ? "nav-link hover-underline-animation active"
                : "nav-link hover-underline-animation"
            }
          >
            View Goals
          </NavLink>
          {/* <NavLink
            to="/app/achievements"
            className={({ isActive }) =>
              isActive
                ? "nav-link hover-underline-animation active"
                : "nav-link hover-underline-animation"
            }
          >
            Achievements
          </NavLink> */}
          {!isLoggedIn ? (
            <NavLink to="/login" className="btn btn-fill">
              Login
            </NavLink>
          ) : (
            <button
              className="btn btn-fill"
              onClick={() => {
                dispatch({ type: "LOGOUT" });
              }}
            >
              Logout
            </button>
          )}
        </nav>
      </div>
    </div>
  );
}

export default Header;
